import { apiSlice } from '../../../api/apiSlice';
import { NOTIFICATION, EMPLOYEE_NOTIFICATIONS, DELETE_NOTIFICATION} from '../../../constants';

export const notification = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getEmployeeNotifications: builder.query({
            query: (arg: any) => {
                const { employeeNumber} = arg;
                return {
                    url: EMPLOYEE_NOTIFICATIONS,
                    params: {employeeNumber },
                };
            },
            providesTags : ['Notification']
        }),
        updateNotification: builder.mutation({
            query: (arg: any) => ({
                url: NOTIFICATION,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Notification'],
        }),
        deleteNotification: builder.mutation({
            query: (arg: any) => ({
                url: DELETE_NOTIFICATION,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Notification'],
        }),
    })
})

export const { useGetEmployeeNotificationsQuery, useUpdateNotificationMutation, useDeleteNotificationMutation } = notification;